import { render, staticRenderFns } from "./VimeoConfiguration.vue?vue&type=template&id=960072e6"
import script from "./VimeoConfiguration.vue?vue&type=script&lang=js"
export * from "./VimeoConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports